<template>
  <div class="format-selection-wrapper">
    <!-- <div class="hd">选择报告格式</div> -->
    <div class="bd">
      <h5>格式选择</h5>
      <bxs-radio-group v-model="typeValue" class="file-type-radio">
        <bxs-radio :name="0" data-stat-id="pdf">
          PDF（方便打印）
        </bxs-radio>
        <bxs-radio
          v-if="isSupportWord"
          :name="1"
          data-stat-id="word"
        >
          Word（方便编辑）
        </bxs-radio>
      </bxs-radio-group>
      <h5>封面模版</h5>
      <show-radio
        v-slot="slotProps"
        v-model="coverValue"
        class="skin-radio"
        :options="coverOptions"
      >
        <div class="radio-content">
          <div
            class="img-bg"
            :class="{
              default: slotProps.item.default || !slotProps.item.image,
            }"
          >
            <img v-if="slotProps.item.image" :src="slotProps.item.image">
          </div>
          <div class="text">
            {{ slotProps.item.label }}
          </div>
        </div>
      </show-radio>
    </div>
  </div>
</template>

<script>
import { isWeCom } from 'base/config'
import { COVER_OPTIONS } from './config'
import ShowRadio from './ShowRadio'
import { RadioGroup, Radio, Icon } from 'bxs-ui-vue'

import Vue from 'vue'
Vue.use(RadioGroup)
Vue.use(Radio)

export default {
  name: 'FormatSelection',
  components: {
    ShowRadio,
    [Icon.name]: Icon
  },
  props: {
    typeval: Number,
    coverval: Number,
    miniprogram: Boolean
  },
  data () {
    return {
      coverOptions: COVER_OPTIONS.filter(item => item.type === 0)
    }
  },
  computed: {
    typeValue: {
      get () {
        return this.typeval
      },
      set (v) {
        this.$emit('update:typeval', v)
      }
    },
    coverValue: {
      get () {
        return this.coverval
      },
      set (v) {
        this.$emit('update:coverval', v)
      }
    },
    isSupportWord () {
      return !isWeCom && !this.miniprogram
    }
  },
  watch: {
    typeValue (v) {
      this.coverOptions = COVER_OPTIONS.filter(item => item.type === v)
    }
  }
}
</script>
<style lang="postcss" scoped>
.format-selection-wrapper {
  background-color: #fff;
  color: #333;
  .hd {
    padding: 0.24rem 0.3rem;
    font-size: 0.34rem;
    font-weight: bold;
  }
  .bd {
    > h5 {
      font-size: 0.34rem;
      font-weight: bold;
      padding: 0.12rem 0.3rem 0.24rem;
    }
    .file-type-radio {
      display: flex;
      padding: 0 0.1rem 0.6rem;
      .bx-radio-warp {
        display: flex;
        align-items: center;
        padding: 0 10px;
      }
      .bx-radio-text {
        font-size: 0.28rem;
      }
    }
    .skin-radio {
      padding: 0 0.05rem;
      .radio-content {
        padding: 0 0.1rem;
        .img-bg {
          margin-bottom: 0.25rem;
          border-radius: 0.15rem;
        }
      }
    }
  }
}

.cover-template {
  display: flex;
  flex-wrap: wrap;
  > li {
    overflow: hidden;
    flex-basis: 33.3%;
  }
}

.radio-content {
  .img-bg {
    position: relative;
    overflow: hidden;
    padding-bottom: 136.8%;
    background-color: #e5e5e5;
    > img {
      position: absolute;
      height: 100%;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
  .text {
    padding-left: 23px;
    font-size: 0.26rem;
  }
}
</style>

<style lang="postcss">
.bx-radio-icon-warp .bx-icon-circle {
  color: #ccc;
}
</style>